module.exports = __webpack_public_path__ + "media/images/city/068-stari-most-502cc87330cd080c60e66b922d25c3de.svg";